import { useWindowSize } from '../../hooks/utility/useWindowSize';
import PageHeader from '../headers/PageHeader';
import { useMemo } from 'react';
import classnames from 'classnames';
import useScreenType from '../../hooks/utility/useScreenType';

interface Props {
  leftColumn?: JSX.Element;
  rightColumn?: JSX.Element;
  children?: JSX.Element;
  header?: JSX.Element;
  footer?: JSX.Element;
  hasHeader?: boolean;
}

const FixedPageLayout = (props: Props): JSX.Element => {
  const { isDesktop } = useScreenType();

  if (!isDesktop) {
    return <FixedPageLayout.Mobile {...props} />;
  }

  return <FixedPageLayout.Desktop {...props} />;
};

export default FixedPageLayout;

FixedPageLayout.Desktop = ({ leftColumn, rightColumn, hasHeader = true }: Props) => {
  const { width } = useWindowSize();
  const { isDesktop } = useScreenType();
  const headerHeight = hasHeader ? 74 : 0;
  const rightColumnWidth = 400;
  const rightColumnHeight = window.innerHeight - headerHeight;
  const rightColumnHeightOffset = 16;

  const responsivePadding = useMemo(() => {
    const viewportWidth = width;
    const calcPadding = (viewportWidth - 1300) / 2;
    const percentPadding = viewportWidth * 0.02;

    const padding = Math.max(percentPadding, calcPadding);

    return padding;
  }, [width]);

  return (
    <>
      {hasHeader && (
        <div className="fixed w-screen top-0 z-50">
          <PageHeader />
        </div>
      )}
      <div className="flex flex-row justify-center w-full layout-container" style={{ marginTop: headerHeight }}>
        <div className="w-full shrink px-lg lg:pr-[100px]">{leftColumn}</div>
        <div className="h-screen  shrink-0" style={{ width: rightColumnWidth }} />
      </div>
      <div
        className="fixed"
        style={{
          width: rightColumnWidth,
          right: responsivePadding,
          top: headerHeight,
          height: rightColumnHeight,
        }}
      >
        <div
          className={classnames('border-xs', {
            'bg-gray-600 dark:bg-black rounded-lg relative': isDesktop,
          })}
          style={{
            height: rightColumnHeight - 2 * rightColumnHeightOffset,
            marginTop: rightColumnHeightOffset,
          }}
        >
          {rightColumn}
        </div>
      </div>
    </>
  );
};

FixedPageLayout.Mobile = ({ children, header, footer }: Props) => {
  return (
    <div className="flex flex-col relative">
      <div className="sticky w-screen top-0 z-50 bg-white shadow-section dark:shadow-none">{header}</div>
      {children}
      <div className="sticky w-screen bottom-0 z-50">{footer}</div>
    </div>
  );
};
